import { VIDEO_LIMIT, PHOTO_LIMIT } from "../core/constants";
import { SelectionModalProps } from "../media/dashboard/SelectionModal";

export const openMediaSelectionModal = (
  openModal: (name: string, modalProps: any) => void,
  onImageSelected: (newImage: string) => void,
  cropAspectRatio: number,
  minSize: {
    height: number;
    width: number;
  },
) => {
  openModal("MEDIA_SELECTION_MODAL", {
    allowMultiSelect: false,
    allowVideoSelect: false,
    cropAspectRatio,
    minSize,
    onSelected: onImageSelected,
  } as SelectionModalProps);
};

const singleFileUploadError = "We were unable to upload your file.";
const multiFileUploadError = "We were unable to upload one of your files.";

export const formatErrorMessage = (
  error,
  isMultipleFiles = true,
  isMultipleErrors = false,
) => {
  // Selection errors
  // Upload errors
  if (isMultipleErrors) {
    return "We were unable to upload some of your selected files.";
  }

  switch (error) {
    case "ImageTooLarge":
      return `${isMultipleFiles ? multiFileUploadError : singleFileUploadError} Photos must be 10MB or smaller.`;
    case "PhotoLimitReached":
      return `${isMultipleFiles ? multiFileUploadError : singleFileUploadError} You can only add ${PHOTO_LIMIT} photos to your Minted Website.`;
    case "VideoTooLarge":
      return `${isMultipleFiles ? multiFileUploadError : singleFileUploadError} Videos must be 3GB or smaller.`;
    case "VideoLimitReached":
      return `${isMultipleFiles ? multiFileUploadError : singleFileUploadError} You can only add ${VIDEO_LIMIT} videos to your Minted Website.`;
    default:
      return `${isMultipleFiles ? multiFileUploadError : singleFileUploadError} Please try again.`;
  }
};
